import script from "./WapEventView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapEventView.vue?vue&type=script&lang=ts&setup=true"

import "./WapEventView.vue?vue&type=style&index=0&id=383475ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383475ea"]])

export default __exports__